import InfoButtonService from '@/services/InfoButtonService.js'

export default {
  namespaced: true,
  state: {
    data: {}
  },
  mutations: {
    SET_URL(state, data) {
      state.data = data
    }
  },
  actions: {
    async fetchData({ commit }) {
      await InfoButtonService.getData()
        .then(response => {
          commit('SET_URL', response)
        })
        .catch(error => {
          console.log(
            'There was a problem fetching the url of infobutton: ' +
              error.message
          )
          throw error
        })
    }
  }
}
